export class SettingsDetailRes {
    id!: number;
    language!: string;
    zoomCommunicationPage!: number;
    zoomContactPage!: number;
    lastSelectedCompanyId!: number;
    lastSelectedTimeManagerView!: boolean;
    favouriteTasks: string[] = []
}

export class SettingsUpdateReq {
    language?: string;
    zoomCommunicationPage?: number;
    zoomContactPage?: number;
    lastSelectedCompanyId?: number;
    lastSelectedTimeManagerView?: boolean;

    constructor(update:Partial<SettingsUpdateReq>) {
        this.language = update.language;
        this.zoomCommunicationPage = update.zoomCommunicationPage;
        this.zoomContactPage = update.zoomContactPage;
        this.lastSelectedCompanyId = update.lastSelectedCompanyId;
        this.lastSelectedTimeManagerView = update.lastSelectedTimeManagerView;
    }
}


